module.exports = __webpack_public_path__ + "img/power2.424a6ff5.png";